"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const map_meta_options_1 = __importDefault(require("./map-meta-options"));
const meta_options_migration_1 = require("./meta-options-migration");
// eslint-disable-next-line max-len
const migrateOptions = (oldMeta, newMeta = null) => { var _a; return (_a = (0, map_meta_options_1.default)(oldMeta, newMeta !== null && newMeta !== void 0 ? newMeta : meta_options_migration_1.newMetaOptions, meta_options_migration_1.mappingMetaOptions)) !== null && _a !== void 0 ? _a : {}; };
exports.default = migrateOptions;
//# sourceMappingURL=migrate-options.js.map